import { WORKFLOW_RUN_STATUSES, workflowSubjectSchema } from '@sahab/contracts'
import { z } from 'zod'

/** The monitor's views; "Needs attention" is the default (no `state` in the URL). */
export const RUN_VIEWS = ['attention', 'active', 'closed', 'all'] as const
export type RunView = (typeof RUN_VIEWS)[number]

/**
 * The run monitor's list state. `workflowId` comes from the workflow screens ("View requests"); a
 * link that names a workflow shows all of its requests unless a view is chosen.
 */
export const runMonitorSearchSchema = z.object({
  workflowId: z.uuid().optional(),
  state: z.enum(['attention', 'active', 'closed', 'all']).optional().catch(undefined),
  status: z.enum(WORKFLOW_RUN_STATUSES).optional().catch(undefined),
  subject: workflowSubjectSchema.optional().catch(undefined),
  q: z.string().trim().max(100).optional().catch(undefined),
  page: z.coerce.number().int().min(2).optional().catch(undefined),
})
export type RunMonitorSearch = z.infer<typeof runMonitorSearchSchema>

/** The view in effect: explicit, else every request of a named workflow, else what needs attention. */
export function runView(search: RunMonitorSearch): RunView {
  return search.state ?? (search.workflowId ? 'all' : 'attention')
}

export const DELEGATION_VIEWS = ['current', 'upcoming', 'past'] as const

export const delegationAdminSearchSchema = z.object({
  state: z.enum(DELEGATION_VIEWS).optional().catch(undefined),
  userId: z.uuid().optional().catch(undefined),
  page: z.coerce.number().int().min(2).optional().catch(undefined),
})
export type DelegationAdminSearch = z.infer<typeof delegationAdminSearchSchema>
